import { render, staticRenderFns } from "./delegate-print.vue?vue&type=template&id=1b3a2ca2&scoped=true&"
import script from "./delegate-print.vue?vue&type=script&lang=ts&"
export * from "./delegate-print.vue?vue&type=script&lang=ts&"
import style0 from "./delegate-print.vue?vue&type=style&index=0&id=1b3a2ca2&prod&lang=scss&media=print&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3a2ca2",
  null
  
)

export default component.exports